import React from 'react'
import {Footer } from '../components'
import Projects from '../components/Projects'
import Meta from '../components/common/Meta'
import image from '../assets/images/services/services-header.jpg'

function ProjectsPage() {
  return (
    <div>
      <Meta
        title="Our Projects | Construction & Design Portfolio"
        description="Explore completed and ongoing construction, architectural, engineering, and sustainable building projects delivered across Rwanda."
        keywords="
          Design and build Rwanda, Turnkey building solutions,
          Turnkey building solutions Africa,
          Construction project management Rwanda,
          Project supervision Kigali,
          Building project planning,
          Construction management services,
          Construction quality control Rwanda,
          Safety & quality control, Safety management Kigali,
          Gestion de projets de construction,
          Métré et estimation des coûts,
          Contrôle qualité chantier,
          Gukurikirana imishinga yo kubaka,
          Kugenzura ingengo y’imari,
          Kugenzura ubuziranenge bw’akazi,
          Building, Structure audit"
    />
      <header className="relative min-h-[320px] flex items-center justify-center overflow-hidden">
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" fetchPriority="high" decoding="async" />
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>

        {/* Content */}
        <div className="relative text-center px-4 z-10">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white uppercase tracking-wide">
            Projects
          </h1>
          <p className="mt-4 text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
            We provide a range of innovative solutions to help you succeed.
          </p>
        </div>
      </header>

      <Projects isPage />
      <Footer />
    </div>
  )
}

export default ProjectsPage
